import { Injectable } from '@angular/core';
import { SurveyService } from 'src/app/core/services/survey/survey.service';
import { FindPersonApiService, PeopleLookupApiService } from '@tangilla/tg-ng-core';
import { PersonRelationship, RequestParameters } from '@tangilla/tg-ng-models';
import { ErrorsService } from 'src/app/core/services/utils/errors.service';

@Injectable({
  providedIn: 'root'
})
export class NonMemberService {

  isLoading = true;
  formatter: Intl.NumberFormat | any;
  dr_workflow: boolean = false;

  constructor(
    private surveyService: SurveyService,
    private peopleLookupApiService: PeopleLookupApiService,
    private findPersonApiService: FindPersonApiService,
    private errorsService: ErrorsService
  ) {
  }

  initializeForm() {
    this.formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    this.initializeOnAfterRenderPage();
    this.initializeOnValueChanged();
  }

  initializeOnAfterRenderPage() {
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch (currentPage.name) {
        case 'Non-Members':
          this.surveyService.surveyModel.setValue('role', this.surveyService.surveyModel.getVariable('non_member_role_code') || 'NEX');
          this.surveyService.surveyModel.setValue('association_product_type', '');
          this.surveyService.surveyModel.setValue('product_type_desc', 'Non Member Education');
          this.surveyService.surveyModel.setValue('MembershipType', 'Non-Member');
          break;
      }
    });
  }

  initializeOnValueChanged() {
    this.surveyService.surveyModel.onValueChanged.add((sender, options) => {
      if (options.name === 'LicNumber') {
        this.processLicenseNumberValueChanges(options);
      } else if (options.name === 'emailaddress' && !this.surveyService.surveyModel.getQuestionByName('LastName').isEmpty()) {
        this.processEmailAddressValueChanges(options);
      }
    });
  }

  private processLicenseNumberValueChanges(options: any) {
    const requestParameters = new RequestParameters(null);
    requestParameters.additionalFields = {
      include_relationships: true,
      license_number: options.value
    };
    this.peopleLookupApiService.get(requestParameters).subscribe({
      next: (response: any) => {
        this.processLicenseNumberPeopleLookup(response);
      },
      error: (error: any) => {
        this.errorsService.processError(error);
      }
    });
  }

  private processLicenseNumberPeopleLookup(response: any) {
    const person = response[0];
    if (person && person.relationships.length > 0 && person.primary_relationship.status === 'active') {
      const firstName = person['first_name'];
      const localBoardName = this.surveyService.surveyModel.getVariable('v-association');
      const title = `Hi ${firstName} !`;
      const message = `You are already active in ${localBoardName}. <br /><br />` +
        `What a you trying to do today ? <br />` +
        `<li><strong>Applying for a new MLS Only Subscription?</strong> A salesperson licensee can't be in more than one office or have multiple MLS Subscriptions</li>` +
        `<li><strong>Adding MLS to your existing subscription?</strong> You will need to add it from the <u>Member Portal</u></li>` +
        `<li><strong>Applying for a DR Transfer?</strong> You will need to complete a <u>DR Transfer Form</u>`;
      this.errorsService.exitForm(title, message);
    }
  }

  private processEmailAddressValueChanges(options: any) {
    const lastName = this.surveyService.surveyModel.getValue('LastName');
    const requestParameters = new RequestParameters(null);
    requestParameters.additionalFields = {
      last_name: lastName,
      email: options.value
    };
    this.findPersonApiService.get(requestParameters).subscribe({
      next: (response: any) => {
        this.processEmailAddressFindPerson(response);
      },
      error: (error: any) => {
        this.errorsService.processError(error);
      }
    });
  }

  private processEmailAddressFindPerson(response: any) {
    if (response.length > 0) {
      const active_relationships = response.find((p: any) => p.relationships.some((r: PersonRelationship) => ['active', 'terminated_by_broker'].includes(r.status)));
      if (active_relationships) {
        this.errorsService.exitForm(`Profile Already Exists`,
          `The details provided (email or phone) are associated with an active profile, a new profile cannot be created.`);
      }
    } else {
      this.surveyService.surveyModel.setValue('person_id', null);
    }
  }
}
